import { i18n } from '@lingui/core'
import './ProductFilterV1PriceRange.scss'
import type { FC } from 'react'

import {
  getPriceDefaultRange,
  getPriceRangeFromResults,
} from 'shared/utils/algolia/filters'
import type { SearchResults, SearchState } from 'types/search'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import { currencyToSymbol } from 'views/components/atoms/Price/helpers'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import { PRICE_DEFAULT_VALUES } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilter/consts'
import { ProductFilterV1FilterCounter } from 'views/components/organisms/AlgoliaInstantSearch/ProductFilterV1/ProductFilterV1FilterCounter/ProductFilterV1FilterCounter'

import ProductFilterV1InputRange from './ProductFilterV1InputRange'

const getDefaultValues = ({
  searchState,
  searchResults,
}: {
  searchState: SearchState
  searchResults: SearchResults
}) => {
  if (searchState && searchResults) {
    const range = getPriceDefaultRange(searchState, searchResults)

    if (range) {
      return range
    }
  }

  return {
    min: PRICE_DEFAULT_VALUES.min,
    max: PRICE_DEFAULT_VALUES.max,
  }
}

const getRangeValues = (searchResults: SearchResults) => {
  if (searchResults) {
    const range = getPriceRangeFromResults(searchResults)

    if (range) {
      return range
    }
  }

  return {
    min: PRICE_DEFAULT_VALUES.min,
    max: PRICE_DEFAULT_VALUES.max,
  }
}

const modalId = 'product-filter-v1-price-range'

export const ProductFilterV1PriceRange: FC<{
  searchState: SearchState
  searchResults: SearchResults
  currency: string
}> = ({ searchState, searchResults, currency }) => {
  return (
    <div className="o-product-filter-v1-price-range">
      {/* @ts-ignore */}
      <ModalShowButton
        component={ButtonAsLink}
        name={modalId}
        modalId={modalId}
        neutral
      >
        <div className="l-flex o-product-filter-v1-price-range__item">
          <p className="u-no-margin l-flex__primary u-text-align--left u-font-weight--semi-bold o-product-filter-v1-price-range__text">
            {i18n._('general.label.sort.price')}{' '}
            <ProductFilterV1FilterCounter attribute="price" />
          </p>
          <IconCaretRight />
        </div>
      </ModalShowButton>
      <Modal
        id={modalId}
        title={i18n._('general.label.sort.price')}
        isClientSideControlled
        fullScreen
      >
        <ProductFilterV1InputRange
          modalId={modalId}
          label={i18n._('general.label.sort.priceRange')}
          attribute="price"
          name="productFilter__rangeInput"
          rangeValues={getRangeValues(searchResults)}
          defaultValues={getDefaultValues({ searchState, searchResults })}
          symbol={currencyToSymbol(currency)}
          delimiterLabel="-"
        />
      </Modal>
    </div>
  )
}
